import React, { ReactNode, useEffect } from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  Container,
  Flex,
  HStack,
  Stack,
  StackSeparator,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { appRoutes } from "../../../App";
import { AdminView } from "../models/AdminView";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { NavTab } from "../../shared/views/NavTab/NavTab";

interface Props {
  selectedView: AdminView;
  children?: ReactNode;
}
const AdminPageWrapperBase: React.FC<Props> = ({ children, selectedView }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = `Backoffice - Lane Patrol`;
  }, []);

  const renderTab = (to: string, view: AdminView) => (
    <NavTab
      onClick={() => navigate(to)}
      isSelected={selectedView === view}
      title={view}
    />
  );

  return (
    <Flex flexDir="column" maxHeight="100vh" flexGrow={1}>
      <AppHeader />
      <AppHeaderHeight />
      <Container
        flexGrow={1}
        display="flex"
        maxW="container.xl"
        overflow="hidden"
        px={0}
      >
        <HStack
          flexGrow={1}
          gap={0}
          separator={<StackSeparator />}
          alignItems="stretch"
        >
          <VStack
            flexShrink={0}
            width="300px"
            overflow="auto"
            alignItems="stretch"
            justifyContent="start"
            py={6}
            pl={2}
          >
            <Box>
              <Text px={2} fontSize="2xl" mb={1}>
                Backoffice
              </Text>
              {renderTab(appRoutes.adminUsers(), AdminView.Users)}
              {renderTab(appRoutes.adminAccounts(), AdminView.Accounts)}
              {renderTab(appRoutes.adminProjects(), AdminView.Projects)}
              {renderTab(appRoutes.adminTools(), AdminView.Tools)}
              {renderTab(appRoutes.adminIntegrations(), AdminView.Integrations)}
            </Box>
          </VStack>
          <Stack flexGrow={1} overflow="auto" py={6} position="relative">
            {children}
          </Stack>
        </HStack>
      </Container>
    </Flex>
  );
};

export const AdminPageWrapper = observer(AdminPageWrapperBase);
